var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0078125H514.002V342.66H0V-0.0078125Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 342.059C350.959 342.059 427.533 265.485 427.533 171.026C427.533 76.5664 350.959 -0.0078125 256.5 -0.0078125C162.041 -0.0078125 85.4666 76.5664 85.4666 171.026C85.4666 265.485 162.041 342.059 256.5 342.059Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.147 171.025L331.446 195.373L359 245.47L302.79 234.749L295.676 291.46L256.5 249.678L217.324 291.46L210.21 234.749L154 245.47L181.554 195.373L129.853 171.025L181.554 146.678L154 96.4799L210.21 107.301L217.324 50.4902L256.5 92.2717L295.676 50.4902L302.79 107.301L359 96.4799L331.446 146.678L383.147 171.025Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.903 242.766C297.523 242.766 329.643 210.647 329.643 171.026C329.643 131.405 297.523 99.2861 257.903 99.2861C218.282 99.2861 186.163 131.405 186.163 171.026C186.163 210.647 218.282 242.766 257.903 242.766Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.618 171.026C212.514 171.026 210.51 171.126 208.406 171.326C208.506 183.35 212.815 194.271 220.029 202.888C223.836 192.568 229.547 183.25 236.762 175.134C229.848 172.429 222.434 171.026 214.618 171.026ZM241.27 217.617C246.48 219.52 252.091 220.522 257.903 220.522C263.714 220.522 269.325 219.52 274.535 217.617C271.73 206.495 265.818 196.576 257.903 188.76C249.987 196.576 244.076 206.495 241.27 217.617ZM300.786 146.278C292.27 131.449 276.238 121.529 257.903 121.529C239.567 121.529 223.636 131.449 215.019 146.278C230.65 146.378 245.278 150.586 257.903 157.9C270.527 150.586 285.156 146.278 300.786 146.278ZM279.044 175.134C286.258 183.149 291.969 192.568 295.777 202.888C302.991 194.371 307.299 183.35 307.399 171.326C305.395 171.126 303.291 171.026 301.187 171.026C293.472 171.026 285.957 172.429 279.044 175.134Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342.668,
    fill: "white",
    transform: "translate(0 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKg);
export default __webpack_public_path__ + "static/media/KG.99400e3c026f9be42870d5b7ed6af35b.svg";
export { ForwardRef as ReactComponent };